export default "__VITE_ASSET__03f86df2__"